<div class="max-w-sm md:p-8 p-5 bg-surface rounded-t" style="min-height: 400px; min-width: 336px">
  <div class="px-4">
    <p tabindex="0" class="focus:outline-none text-base font-bold text-fg-primary">
      {{ monthTitle }}
    </p>
    <p class="text-sm text-fg-secondary">{{ totalWorkMonth }}h</p>
  </div>
  <div class="flex items-center justify-between pt-10 overflow-x-auto">
    <table class="w-full border-separate border-spacing-1">
      <thead>
        <tr>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Mo</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Di</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Mi</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Do</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Fr</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">Sa</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-center">
              <p class="text-base font-medium text-center text-fg-subtle">So</p>
            </div>
          </th>
          <th>
            <div class="w-full flex justify-end">
              <p class="text-sm font-medium text-center text-fg-secondary">Σ</p>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (week of weeks; track week.startOfWeek; let isFirstWeek = $first) {
          <tr>
            @for (day of week.days; track day) {
              <td [class.pt-6]="isFirstWeek" (click)="selectedDateChange.emit(day.date)">
                @if (day.isInCurrentMonth) {
                  @if (!day.isSelected && !day.isCurrentDate) {
                    <div
                      class="cursor-pointer flex justify-center relative rounded-lg"
                      [class]="workLoadClass(day.work)"
                    >
                      <div class="flex items-center justify-center rounded-full w-8 h-8">
                        <p class="text-base text-fg-secondary font-medium">
                          {{ day.dayOfMonth }}
                        </p>
                      </div>
                      @if (warningDays?.includes(day.date)) {
                        <app-ng-icon
                          class="rounded-full bg-surface absolute text-warning-icon text-xs left-0 top-0 -ml-1 -mt-1"
                          name="heroExclamationCircleMini"
                        ></app-ng-icon>
                      }
                    </div>
                  } @else {
                    @if (day.isSelected) {
                      <div class="w-full h-full">
                        <div
                          class="flex items-center justify-center w-full rounded-full cursor-pointer"
                        >
                          <p
                            class="text-base w-8 h-8 flex items-center justify-center font-medium text-on-primary bg-primary rounded-full"
                          >
                            {{ day.dayOfMonth }}
                          </p>
                        </div>
                      </div>
                    } @else {
                      <div class="cursor-pointer flex justify-center">
                        <div
                          class="flex items-center justify-center rounded-full w-8 h-8 border-2 border-primary"
                          [class]="workLoadClass(day.work)"
                        >
                          <p class="text-base text-fg-secondary font-medium">
                            {{ day.dayOfMonth }}
                          </p>
                        </div>
                      </div>
                    }
                  }
                }
              </td>
            }
            <td [class.pt-6]="isFirstWeek">
              <div class="flex justify-end content-end w-10">
                <p class="text-xs text-fg-faint truncate">
                  {{ week.work }}
                </p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
